
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
// Entities
import { Profile } from "@/entities/index";

@Component
export default class IdeaBox extends Vue {
  dialog = false;
  rating = 3.5;
  message = "";
  snackbar = false;

  // ========== CRUD ========== //

  async createIdea(): Promise<void> {
    const userId = this.profile.id;
    await axios.post("/api/feedbacks", {
      userId,
      stars: this.rating,
      message: this.message,
    });
  }

  // ========== GETTERS & SETTERS ========== //

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  // ========== OTHER METHODS ========== //

  show(): void {
    this.dialog = true;
  }

  sendIdea(): void {
    this.createIdea();
    this.dialog = false;
    this.snackbar = true;
    this.rating = 4;
    this.message = "";
  }

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.rating = 3.5;
    this.message = "";
  }
}
